
import type { PropType } from 'vue'
import type { ClusterFeatureEntity } from '@/modules/DispatcherWorkplaceModule/types'
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import { defineComponent, computed } from 'vue'

type Segment = {
    percentage: number
    color: string
}

export default defineComponent({
    props: {
        number: {
            type: Number,
            default: 0
        },
        size: {
            type: Number,
            default: 50
        },
        segments: {
            type: Array as PropType<Segment[]>,
            default: () => []
        },
        features: {
            type: Array as PropType<Array<ClusterFeature<ClusterFeatureEntity>>>,
            default: () => []
        }
    },
    setup(props) {
        const getBackgroundValue = () => {
            if (!props.segments || props.segments.length === 0) return ''

            let background = 'conic-gradient('
            let accumulatedPercentage = 0

            background += props.segments.map((segment, i) => {
                const start = accumulatedPercentage
                const end = accumulatedPercentage + segment.percentage
                accumulatedPercentage = end
                return `${segment.color} ${start}% ${end}%`
            }).join(', ')

            background += ')'
            
            return background
        }

        const computedStyles = computed(() => {
            return {
                width: `${props.size}px`,
                height: `${props.size}px`,
                background: getBackgroundValue()
            }
        })

        return {
            computedStyles
        }
    }
})
